module.exports = __webpack_public_path__ + "img/package.494b1876.svg";